export const client_access_management = [{
  permission: 'MANAGE_USER',
  to: '/client/access-management/users?sortBy=userName&orderBy=ASC&page=1&pageSize=10',
  title: 'User'
}, {
  permission: 'MANAGE_ROLE',
  to: '/client/access-management/roles?sortBy=roleName&orderBy=ASC&page=1&pageSize=10',
  title: 'Role'
}]


export const route_management = [
  {
    permission: 'MANAGE_ROUTES',
    to: '/client/route-management/route-maintenance',
    title: 'Route Maintenance'
  },
  // {
  //   permission: 'MANAGE_SERVICE_STOP',
  //   to: '/client/route-management/service-stop-maintenance',
  //   title: 'Service Stop Maintenance'
  // }
];

export const lockBox = [
  {
    permission: 'MANAGE_COUPON_BATCH',
    to: '/client/lockbox/coupons',
    title: 'Coupon Batch'
  },
  {
    permission: 'MANAGE_LOCKBOX_BATCH',
    to: '/client/lockbox/lockbox-batch',
    title: 'Lockbox Batch'
  },
]


export const systemSettings = [
  {
    permission: 'MANAGE_MASTERS',
    to: '/client/system-settings/tax-fee-types',
    title: 'Tax/Fee Types'
  },
  {
    permission: 'MANAGE_MASTERS',
    to: '/client/system-settings/material-types',
    title: 'Material Types'
  },
  {
    permission: 'MANAGE_MASTERS',
    to: '/client/system-settings/commodity-types',
    title: 'Commodity Types'
  },
  {
    permission: 'MANAGE_MASTERS',
    to: '/client/system-settings/vehicle-types',
    title: 'Vehicle Types'
  },
  {
    permission: 'MANAGE_MASTERS',
    to: '/client/system-settings/container-types',
    title: 'Container Types'
  },
  {
    permission: 'MANAGE_MASTERS',
    to: '/client/system-settings/container-type-options',
    title: 'Container Type Options'
  },
  {
    permission: 'MANAGE_MASTERS',
    to: '/client/system-settings/container-size-models',
    title: 'Container Size/Models'
  },
  {
    permission: 'MANAGE_MASTERS',
    to: '/client/system-settings/service-types',
    title: 'Service Types'
  },
  {
    permission: 'MANAGE_MASTERS',
    to: '/client/system-settings/distribution-types',
    title: 'Distribution Types'
  },
  {
    permission: 'MANAGE_MASTERS',
    to: '/client/system-settings/rate-detail-descriptions',
    title: 'Rate Detail Descriptions'
  },
  {
    permission: 'MANAGE_MASTERS',
    to: '/client/system-settings/jurisdictions',
    title: 'Jurisdictions'
  },
  {
    permission: 'MANAGE_MASTERS',
    to: '/client/system-settings/rate-types',
    title: 'Rate Types'
  },
  {
    permission: 'MANAGE_DISPATCH_ADDRESS_MASTERS',
    to: '/client/system-settings/dispatch-address',
    title: 'Site Addresses'
  },
  {
    permission: 'MANAGE_SCALE',
    to: '/client/system-settings/scale-master',
    title: 'Scale Master'
  },
  {
    permission: 'MANAGE_SCALE',
    to: '/client/system-settings/scale-house-master',
    title: 'Scale House Master'
  },
  {
    permission: 'MANAGE_VEHICLE_DETAIL',
    to: '/client/system-settings/vehicle-details',
    title: 'Vehicle Details'
  },
]

export const client_logs_and_history = [
  {
    permission: 'EMAIL_LOG',
    to: '/client/log-history/email?sortBy=emailSentOn&orderBy=DESC&page=1&pageSize=10',
    title: 'Email Log History'
  },
  {
    permission: 'USER_ACTION_HISTORY',
    to: '/client/log-history/user?sortBy=actionTime&orderBy=DESC&page=1&pageSize=10',
    title: 'User Action History'
  },
  {
    permission: 'SCHEDULER_LOGS',
    to: '/client/log-history/schedularLog?sortBy=startedProcessingOn&orderBy=DESC&page=1&pageSize=10',
    title: "Scheduler Log History"
  }
]


